import { Button } from '../design-system/Button';
import { Text } from '../design-system/Text';
import { formatCurrency } from '../../utils/format';

interface PayNowButtonProps {
  total: number;
  count: number;
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

export function PayNowButton({
  total,
  count,
  onClick,
  disabled,
  label = 'Pay Now',
}: PayNowButtonProps) {
  return (
    <Button
      size="lg"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      aria-label={`${label}, total ${formatCurrency(total)} for ${count} challan${count !== 1 ? 's' : ''}`}
    >
      <div className="flex w-full items-center justify-between">
        <span className="font-semibold">{label}</span>
        <div className="flex flex-col items-end">
          <Text as="span" variant="label" color="primary" className="text-white/90">
            {count} selected
          </Text>
          <Text as="span" variant="title" color="primary" className="text-white">
            {formatCurrency(total)}
          </Text>
        </div>
      </div>
    </Button>
  );
}
